import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors, typography } from '../../../../styles/theme';
import { UF_WIZARD_STEP } from '../../../utils/ufAttributeFormUtils';

const STEPS = [
  { id: UF_WIZARD_STEP.BUILDING_TYPE, label: 'Tipo' },
  { id: UF_WIZARD_STEP.LISTING, label: 'Publicación' },
  { id: UF_WIZARD_STEP.ATTRIBUTES, label: 'Características' },
];

const UfWizardStepper = ({
  activeStep = UF_WIZARD_STEP.BUILDING_TYPE,
  onStepClick,
  disabled = false,
}) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 0,
      width: '100%',
      px: 0.25,
      pb: 0.25,
    }}
  >
    {STEPS.map((step, index) => {
      const isActive = activeStep === step.id;
      const isDone = activeStep > step.id;
      const isLast = index === STEPS.length - 1;
      const canNavigate = Boolean(onStepClick) && isDone && !disabled;

      return (
        <Box
          key={step.id}
          sx={{
            display: 'flex',
            alignItems: 'center',
            flex: isLast ? '0 0 auto' : 1,
            minWidth: 0,
          }}
        >
          <Box
            component={canNavigate ? 'button' : 'div'}
            type={canNavigate ? 'button' : undefined}
            onClick={canNavigate ? () => onStepClick(step.id) : undefined}
            aria-current={isActive ? 'step' : undefined}
            aria-label={canNavigate ? `Ir al paso ${step.label}` : undefined}
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 0.75,
              minWidth: 0,
              p: 0,
              m: 0,
              border: 'none',
              background: 'none',
              font: 'inherit',
              color: 'inherit',
              cursor: canNavigate ? 'pointer' : 'default',
              borderRadius: '8px',
              transition: 'opacity 0.15s ease',
              '&:hover': canNavigate ? { opacity: 0.88 } : undefined,
              '&:focus-visible': canNavigate ? {
                outline: `1px solid ${colors.primary}`,
                outlineOffset: 2,
              } : undefined,
            }}
          >
            <Box
              sx={{
                width: 22,
                height: 22,
                borderRadius: '50%',
                flexShrink: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid',
                borderColor: isActive || isDone ? colors.primary : 'rgba(255,255,255,0.18)',
                bgcolor: isActive ? colors.primary : (isDone ? 'rgba(72,146,145,0.28)' : 'transparent'),
              }}
            >
              <Typography
                sx={{
                  fontSize: '11px',
                  fontWeight: typography.fontWeight.semibold,
                  fontFamily: typography.fontFamily.primary,
                  color: isActive ? '#FFFFFF' : (isDone ? '#E8F4F4' : 'rgba(255,255,255,0.40)'),
                  lineHeight: 1,
                }}
              >
                {index + 1}
              </Typography>
            </Box>
            <Typography
              sx={{
                fontSize: '13px',
                fontWeight: isActive ? typography.fontWeight.semibold : typography.fontWeight.medium,
                fontFamily: typography.fontFamily.primary,
                color: isActive
                  ? colors.textPanelTitle
                  : (isDone ? 'rgba(232,244,244,0.85)' : 'rgba(255,255,255,0.38)'),
                whiteSpace: 'nowrap',
              }}
            >
              {step.label}
            </Typography>
          </Box>

          {!isLast && (
            <Box
              sx={{
                flex: 1,
                height: '1px',
                mx: 1.25,
                minWidth: 12,
                bgcolor: isDone ? 'rgba(72,146,145,0.55)' : 'rgba(255,255,255,0.12)',
              }}
            />
          )}
        </Box>
      );
    })}
  </Box>
);

export default UfWizardStepper;
